<!-- SIDE PANEL -->
@if (!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'left') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<div id="main">
  <!-- TOOLBAR: Above -->
  @if (fuseConfig.layout.toolbar.position === 'above') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above -->

  <div class="container" id="container-1">
    <!-- NAVBAR: Left -->
    @if (fuseConfig.layout.navbar.position === 'left') {
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    }
    <!-- / NAVBAR: Left -->

    <div class="container" id="container-2">
      <app-context-menu-holder id="context-menu-holder"></app-context-menu-holder>

      <!-- TOOLBAR: Below fixed -->
      @if (fuseConfig.layout.toolbar.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }
      <!-- / TOOLBAR: Below fixed -->
      <div class="container" id="container-3">
        <div class="container" id="container-reference-for-fixed-elements">
          <app-customer-area-message-banner class="whole-width"></app-customer-area-message-banner>
          <app-laboratory-area-message-banner class="whole-width"></app-laboratory-area-message-banner>
          <app-subscription-banner class="whole-width"></app-subscription-banner>
          <app-storage-banner class="whole-width"></app-storage-banner>
          <div cdkScrollable class="container" id="container-4">
            <!-- TOOLBAR: Below static -->
            @if (fuseConfig.layout.toolbar.position === 'below-static') {
              <ng-container *ngTemplateOutlet="toolbar"></ng-container>
            }
            <!-- / TOOLBAR: Below static -->
            <!-- CONTENT -->
            <app-content></app-content>
            <!-- / CONTENT -->

            <!-- FOOTER: Below static -->
            @if (fuseConfig.layout.footer.position === 'below-static') {
              <ng-container *ngTemplateOutlet="footer"></ng-container>
            }
            <!-- / FOOTER: Below static -->
          </div>
        </div>
        <!-- SIDEBAR: Right [fxHide]="!fuseConfig.layout.rightSidebar?.opened" -->
        @if (!fuseConfig.layout.rightSidebar?.hidden) {
          <ng-container *ngTemplateOutlet="rightSidebar"></ng-container>
        }
        <!-- / SIDEBAR: Right -->
      </div>

      <!-- FOOTER: Below fixed -->
      @if (fuseConfig.layout.footer.position === 'below-fixed') {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
      <!-- / FOOTER: Below fixed -->
    </div>
  </div>

  <!-- FOOTER: Above -->
  @if (fuseConfig.layout.footer.position === 'above') {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above -->
</div>

<!-- SIDE PANEL -->
@if (!fuseConfig.layout.sidepanel.hidden && fuseConfig.layout.sidepanel.position === 'right') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS                                                                                            -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (!fuseConfig.layout.toolbar.hidden) {
    <app-toolbar
      [ngClass]="
        fuseConfig.layout.toolbar.customBackgroundColor === true
          ? fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background
          : fuseConfig.layout.toolbar.position
      "
    >
    </app-toolbar>
  }
</ng-template>

<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!fuseConfig.layout.footer.hidden) {
    <app-footer
      [ngClass]="
        fuseConfig.layout.footer.customBackgroundColor === true
          ? fuseConfig.layout.footer.position + ' ' + fuseConfig.layout.footer.background
          : fuseConfig.layout.footer.position
      "
    ></app-footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!fuseConfig.layout.navbar.hidden) {
    <fuse-sidebar
      [folded]="fuseConfig.layout.navbar.folded"
      class="navbar-fuse-sidebar"
      id="left-fuse-sidebar"
      lockedOpen="gt-md"
      name="navbar"
    >
      <app-navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar"></app-navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT SIDEBAR -->
<ng-template #rightSidebar>
  @if (!fuseConfig.layout.rightSidebar?.hidden) {
    <fuse-sidebar
      (openedChanged)="sidebarOpenedChangedHandler($event)"
      [class.open]="false"
      [folded]="$any(fuseConfig.layout.rightSidebar)?.folded"
      [ngClass]="{ 'gt-xs-positioned': true, 'right-sidebar-hidden': fuseConfig?.layout?.rightSidebar?.hidden }"
      [showBackdropFlag]="false"
      class="right-sidebar"
      name="rightSidebar"
      position="right"
    >
      <app-sidebar #_sidebarComponent></app-sidebar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / RIGHT SIDEBAR -->
